import request from '@/services/request';

/** 获取订单结算页token */
export async function getConfirmToken(params: API.ConfirmTokenInfoReq) {
  return request<API.CommonResponse<API.ConfirmTokenInfoRes>>({
    url: '/api/mall/rest/package/order/web/generateConfirmToken',
    method: 'POST',
    data: params,
    header: { authLogin: true },
  });
}
/** 获取订单结算页token */
export async function generateConfirmToken(params: API.ConfirmTokenInfoReq) {
  return request<API.CommonResponse<API.ConfirmTokenInfoRes>>({
    url: '/api/mall/rest/package/order/web/generateConfirmToken',
    method: 'POST',
    data: params,
    header: { authLogin: true },
  });
}

/** 查询确认页Token信息 */
export async function getComfirmTokenInfo(token: string) {
  return request<API.CommonResponse<API.ProductServiceConfirmTokenInfoVO>>({
    url: 'api/mall/rest/package/order/web/getConfirmTokenInfo',
    method: 'POST',
    data: { token },
    headers: { authLogin: true },
  });
}

/** 根据Token信息获取订单确认页信息 */
export async function getOrderComfirmInfo(
  params: API.ProductServiceConfirmReq,
) {
  return request<API.CommonResponse<API.ProductServiceOrderConfirmVO>>({
    url: '/api/mall/rest/package/order/web/getConfirm',
    method: 'POST',
    data: params,
    headers: { authLogin: true },
  });
}

/** 创建订单 */
export async function createOrder(params: API.ProductServiceCreateOrderReq) {
  return request<API.CommonResponse<API.ProductServiceCreateVO>>({
    url: '/api/mall/rest/package/order/web/createOrder',
    method: 'POST',
    data: params,
    headers: { authLogin: true },
  });
}

/** 发起支付 */
export async function initPayment(params: API.OrderInitPaymentReq) {
  return request<API.CommonResponse<{ payData?: string }>>({
    url: '/api/mall/rest/package/order/web/initPayment',
    method: 'POST',
    data: params,
  });
}

/** 获取支付结果 */
export async function getOrderResult(tradeNo: string) {
  return request<API.CommonResponse<API.OrderPaymentResult>>({
    url: '/api/disp/mall/rest/order/getResult',
    method: 'POST',
    data: { tradeNo },
    headers: { authLogin: true },
  });
}

/** 订单单列表查询接口 */
export async function getOrderList(params: API.ProductServiceOrderPageReq) {
  return request<API.CommonPageInfoResponse<API.ProductServiceOrderPageVO[]>>({
    url: '/api/mall/rest/package/order/web/page',
    data: params,
    method: 'POST',
  });
}
/** 修改交期 */
export async function updatePredictArrivalTime(
  params: API.UpdatePredictArrivalTimeReq,
) {
  return request<API.CommonPageInfoResponse>({
    url: '/api/mall/rest/package/order/web/updatePredictArrivalTime',
    data: params,
    method: 'POST',
  });
}

/** 再来一单，商品列表展示 */
export async function getOrderAgainList(params: API.CartByOrderReq) {
  return request<API.CommonResponse<API.ToBCartShopVO[]>>({
    url: '/api/disp/mall/rest/cart/item/showListItemInfo',
    method: 'POST',
    data: params,
    header: { authLogin: true },
  });
}

export async function getOrderProduceDetail(params: { orderNo: string }) {
  return request<API.CommonResponse<API.OrderProduceDetailRes>>({
    url: '/api/mall/rest/package/order/web/getOrderProduceDetail',
    method: 'POST',
    data: params,
    header: { authLogin: true },
  });
}

export async function addOrderComment(params: API.OrderCommentReq) {
  return request<API.CommonResponse<any>>({
    url: '/api/mall/rest/package/order/web/addOrderComment',
    method: 'POST',
    data: params,
    header: { authLogin: true },
  });
}
/** 修改交期 */
export async function getDeliveryDetail(params: API.OrderNoReq) {
  return request<
    API.CommonPageInfoResponse<API.ProductServiceOrderDeliveryDetailVO>
  >({
    url: '/api/mall/rest/package/order/web/getDeliveryDetail',
    data: params,
    method: 'POST',
  });
}

/** 修改交期 */
export async function payment(params: { orderNoList: { orderNo: string }[] }) {
  return request<API.CommonResponse<API.PaymentRes>>({
    url: '/api/mall/rest/package/order/web/initPayment',
    data: params,
    method: 'POST',
  });
}

/** 取消订单 */
export async function cancelOrder(orderNo: string) {
  return request<API.CommonResponse<API.PaymentRes>>({
    url: '/api/mall/rest/package/order/web/cancel',
    data: { orderNo },
    method: 'POST',
  });
}
